@layer overridable {
    .root video:not(:has(source)) {
        // assumption that covers the most common video aspect ratio in
        // situations where the video hasn't loaded yet
        aspect-ratio: 16 / 9;
    }
}

.root {
    position: relative;
    width: 100%;
    height: 100%;

    video {
        display: block;

        &:not(:has(source)) {
            // so you can see the spinner
            background-color: var(--black);
        }
    }
}

.button {
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    border: none;
    cursor: pointer;
    z-index: 10;
}

.clickable {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--dark-overlay-20);
    border-radius: var(--border-radius-md);
    transition: background-color 0.3s;

    &:hover {
        background-color: var(--dark-overlay-40);
    }

    > span {
        display: contents;
    }

    & svg {
        color: var(--white);
    }
}

.playControl {
    composes: button;
    bottom: var(--spacer-24);
    gap: var(--spacer-8);
    right: var(--spacer-24);

    button {
        width: var(--spacer-40);
        height: var(--spacer-40);
    }

    svg {
        height: 16px;
        width: 16px;
    }
}

.loaderOverlay {
    position: absolute;
    inset: 0;
    background-color: rgb(var(--white-base) / 30%);
    backdrop-filter: blur(3px);
    transition: opacity 0.2s;
    z-index: 1;
}

.loaderContainer {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
    z-index: 2;

    svg {
        min-width: 66px;
        width: 10%;
        height: auto;
    }
}

.centeredPlayButton {
    composes: button;
    inset: 0;

    &:focus {
        outline: none;

        & .centeredPlayButtonIcon {
            outline: var(--outline);
        }
    }
}

.centeredPlayButtonIcon {
    composes: clickable;
    width: var(--spacer-64);
    height: var(--spacer-64);
    border-radius: var(--border-radius-lg);

    svg {
        width: var(--spacer-32);
        height: var(--spacer-32);
    }
}
